import * as R from 'ramda'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { delayWhen, switchMap } from 'rxjs/operators'
import {
  getContext,
  getHomePageUrl
} from 'store/selectors'
import * as Actions from 'store/actions/index.ts'

export const handleClosedSale = (actions$, state$) => actions$.pipe(
  delayWhen(() => R.isEmpty(getContext(state$.value))
    ? actions$.pipe(
      ofType(Actions.context.SET_CONTEXT),
      switchMap(() => of({}))
    )
    : of({})
  ),
  switchMap(() => {
    const homePageUrl = getHomePageUrl(state$.value)

    window.location.replace(homePageUrl)
    return of({})
  })
)
